import { render, staticRenderFns } from "./ErrorLicenseAdminNoLicense.vue?vue&type=template&id=4b423350&scoped=true&"
import script from "./ErrorLicenseAdminNoLicense.vue?vue&type=script&lang=js&"
export * from "./ErrorLicenseAdminNoLicense.vue?vue&type=script&lang=js&"
import style0 from "./ErrorLicenseAdminNoLicense.vue?vue&type=style&index=0&id=4b423350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b423350",
  null
  
)

export default component.exports